import { CategoryConfig, CookbookFilterConfig, ComplexitiesResponse } from '../types';

export interface CookbookFilterConfigArguments {
  complexities: ComplexitiesResponse;
  categories: CategoryConfig[];
}

export const getCookbookFilterConfig = ({ complexities, categories }: CookbookFilterConfigArguments): CookbookFilterConfig => {
  const beginnerComplexityConfig = complexities.find((item) => item.complexity === 'beginner');
  const intermediateComplexityConfig = complexities.find((item) => item.complexity === 'intermediate');
  const advancedComplexityConfig = complexities.find((item) => item.complexity === 'advanced');

  if (!beginnerComplexityConfig || !intermediateComplexityConfig || !advancedComplexityConfig) {
    console.warn('Complexity config missing, replacing with 0 recipes count');
  }

  return {
    complexity: {
      beginner: beginnerComplexityConfig || { complexity: 'beginner', recipesCount: 0 },
      intermediate: intermediateComplexityConfig || { complexity: 'intermediate', recipesCount: 0 },
      advanced: advancedComplexityConfig || { complexity: 'advanced', recipesCount: 0 },
    },
    categories,
  };
};
